import React from 'react';
import { Avatar, Button } from 'antd';
import { ExportOutlined, UserOutlined } from '@ant-design/icons';
import { useBroadcastLogout, useClearSessionAndRedirectToLogin, useCurrentUser } from '../../context/hooks';
import { logout } from '../../services';
import css from './SidebarAccountFooter.module.css';
import { useProfileModal } from '../../pages/GroupOwner/ProfileModalContext';

const SidebarAccountFooter: React.FC = () => {
  const currentUser = useCurrentUser();
  const clearSessionAndRedirectToLogin = useClearSessionAndRedirectToLogin();
  const broadcastLogout = useBroadcastLogout();
  const { openProfile } = useProfileModal();

  const fullName = `${currentUser?.firstName || ''} ${currentUser?.lastName || ''}`.trim() || 'Account User';
  const email = currentUser?.email || 'No email';

  const handleLogout = async () => {
    try {
      await logout();
    } catch (error) {
      console.error('Logout error', error);
    } finally {
      clearSessionAndRedirectToLogin();
      broadcastLogout();
    }
  };

  const handleProfileClick = () => {
    openProfile();
  };

  return (
    <div className={css.footerRoot}>
      <div className={css.footerFade} aria-hidden />
      <div className={css.footer}>
        <Button type="default" block className={css.logoutButton} onClick={handleLogout} icon={<ExportOutlined />}>
          Logout
        </Button>
        <button type="button" className={css.profileCard} onClick={handleProfileClick}>
          <div className={css.avatarWrap}>
            <Avatar src={currentUser?.avatar} icon={<UserOutlined />} size={48} />
            <span className={css.onlineDot} />
          </div>
          <div className={css.userMeta}>
            <div className={css.userName}>{fullName}</div>
            <div className={css.userEmail}>{email}</div>
          </div>
        </button>
      </div>
    </div>
  );
};

export default SidebarAccountFooter;
